import { Theme } from "@mui/material";

export const editBusinessProfileStyles = {
  mainContainer: (theme: Theme) => ({
    width: {
      xs: "100vw",
      sm: "70vw",
      md: "50vw",
    },
    fontFamily: theme.typography.fontFamily,
  }),
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  requiredText: {
    color: "gray",
    fontSize: "0.8rem",
  },
  cancelText: { color: "green", cursor: "pointer" },
  editPhotoText: {
    fontSize: "17px",
    fontWeight: "600",
    textDecoration: "underline",
    cursor: "pointer",
  },
};
